import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Select,
  Form,
  Row,
  Col,
} from "antd";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { CompanyTypes, TiepSchemaTypes } from "_helpers";
import { companyService, currencyService, companyCategoryService } from "_services";


function Add({ history, match }) {
  const [isLoading, setIsLoading] = useState(false);
  const [currencies, setCurrencies] = useState([]);
  const [categories, setCategories] = useState([]);

  const [form] = Form.useForm();
  const { Option } = Select;

  useEffect(() => {
    getCurrencies();
    getCategories();
  }, []);

  const getCurrencies = () => {
    setIsLoading(true);
    currencyService
      .getSuggestion()
      .then((x) => {
        setIsLoading(false);
        setCurrencies(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const getCategories = () => {
    setIsLoading(true);
    companyCategoryService
      .getSuggestion()
      .then((x) => {
        setIsLoading(false);
        setCategories(x.content);
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const handleFormSumbit = () => {
    form
      .validateFields()
      .then((values) => {
        setIsLoading(true);
        const payload = {
          ...values,
          companyCategories:
            values.companyCategories?.map((id) => ({ id })) || [],
        };
        companyService
          .create(payload)
          .then(() => {
            setIsLoading(false);
            history.push(".");
          })
          .catch((error) => {
            setIsLoading(false);
            message.error(`${error}`);
          });

      })
      .catch((error) => {
        //message.error(`${error}`);
      });
  };

  const onCancel = () => {
    history.push(".");
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/companies">Company Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/companies/add">New Company</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={[
          <Button
            key="1"
            htmlType="submit"
            loading={isLoading}
            onClick={handleFormSumbit}
          >
            Save
          </Button>,
          <Button key="2" htmlType="button" onClick={onCancel}>
            Cancel
          </Button>,
        ]}
      >
        <Page inner>
          <Form
            form={form}
            name="form-create"
            layout="vertical"
            requiredMark={false}
          >
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item name="importerNo" label="TIN Number">
                  <Input placeholder="TIN Number" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name="vatNo" label="VAT Number">
                  <Input placeholder="VAT Number" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={["tiepSchemeType"]} label="TIEP Schema Type">
                  <Select placeholder="Select TIEP Schema Type" allowClear>
                    {TiepSchemaTypes.map((type) => (
                      <Option value={type.value} key={type.value}>
                        {type.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="companyType"
                  label="Type"
                  rules={[
                    { required: true, message: "Company type is required" },
                  ]}
                >
                  <Select placeholder="Please select">
                    {CompanyTypes.map((t) => (
                      <Option value={t.value} key={t.value}>
                        {t.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
               <Col span={6}>
                <Form.Item
                  name="code"
                  label="Company Code"
                  rules={[{ required: true, message: "Code is required" }]}
                >
                  <Input placeholder="Code" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="name"
                  label="Name"
                  rules={[{ required: true, message: "Name is required" }]}
                >
                  <Input placeholder="Name" />
                </Form.Item>
              </Col>
             <Col span={12}>
                <Form.Item name="companyCategories" label="Company Categories">
                  <Select
                    mode="multiple"
                    placeholder="Select Company Categories"
                    allowClear
                  >
                    {categories.map((c) => (
                      <Option value={c.id} key={c.id}>
                        {c.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              {/* <Col span={6}>
                <Form.Item name="tiepApprovalNo" label="Warehouse Code">
                  <Input placeholder="Warehouse Code" />
                </Form.Item>
              </Col> */}
              
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item
                  name="emails"
                  label="Emails"
                  rules={[{ required: true, message: "Emails are required" }]}
                >
                  <Input placeholder="Emails" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="contactName"
                  label="Contact Name"
                  rules={[
                    { required: false, message: "Contact Name is required" },
                  ]}
                >
                  <Input placeholder="Contact Name" />
                </Form.Item>
                {/* <Form.Item
                  name={["currency", "id"]}
                  label="Currency"
                  rules={[{ required: false, message: "Currency is required" }]}
                >
                  <Select placeholder="Please select" allowClear>
                    {currencies.length > 0 &&
                      currencies.map((t) => (
                        <Option value={t.id} key={t.id}>
                          {t.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item> */}
              </Col>
              <Col span={6}>
                <Form.Item
                  name="contactNumber"
                  label="Contact Number"
                  rules={[
                    { required: false, message: "Contact Number is required" },
                  ]}
                >
                  <Input placeholder="Contact Number" />
                </Form.Item>
              </Col>
              

            </Row>
          </Form>
        </Page>
      </PageHeader>
    </div>
  );
}

export default Add;
